// A headline value tile with the represented line (DQ-12b) under it: the
// distributed total by default, "Represented: $23.7B" as a second line, and an
// "include represented" toggle that swaps in the total with them. Represented
// entries (Figure HELOC) are records of off-chain assets investors cannot hold,
// so they are never in the default figure.

import { useState, type ReactNode } from "react";

import { REPRESENTED_MEANING, type RepresentedLine } from "../classes";
import { compactUsd } from "../format";
import styles from "./RepresentedTile.module.css";

export function RepresentedTile({
  label,
  value,
  note,
  line,
  complete,
}: {
  label: string;
  /** The distributed figure, already formatted ("≥ $6.96B"). */
  value: string;
  note?: ReactNode;
  line: RepresentedLine | null;
  /** Whether the distributed figure is a complete total (else the inclusive one is a floor too). */
  complete: boolean;
}) {
  const [include, setInclude] = useState(false);
  const inclusive = include && line?.inclusiveUsd != null ? line.inclusiveUsd : null;
  return (
    <li className="tile">
      <span className="tile-label">{inclusive !== null ? `${label} · incl. represented` : label}</span>
      <span className="tile-value" data-absent={value === "—" && inclusive === null}>
        {inclusive !== null ? `${complete ? "" : "≥ "}${compactUsd(inclusive)}` : value}
      </span>
      {inclusive !== null ? (
        <span className="tile-note">
          {value} distributed + {compactUsd(line!.valueUsd ?? 0)} represented
        </span>
      ) : note ? (
        <span className="tile-note">{note}</span>
      ) : null}
      {line ? (
        <span className={styles.line}>
          <span title={REPRESENTED_MEANING}>
            Represented: <strong>{line.valueUsd === null ? "unavailable this run" : compactUsd(line.valueUsd)}</strong>
            {inclusive === null ? " · not in this total" : ""}
          </span>
          <label className={styles.toggle}>
            <input checked={include} disabled={line.inclusiveUsd === null} onChange={(e) => setInclude(e.target.checked)} type="checkbox" />
            include represented
          </label>
        </span>
      ) : null}
    </li>
  );
}
